import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const DiscoverBlock = makeShortcode("DiscoverBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <DiscoverBlock slots="heading, link, text" mdxType="DiscoverBlock" />
    <h3 {...{
      "id": "api-usage"
    }}>{`API Usage`}</h3>
    <p><a parentName="p" {...{
        "href": "/experience-cloud/cloud-manager/src/pages/guides/api-usage/receiving-events.md"
      }}>{`Receiving Events`}</a></p>
    <p>{`Understand how events are structured.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "/experience-cloud/cloud-manager/src/pages/guides/api-usage/understanding-metric-data.md"
      }}>{`Understanding Metric Data`}</a></p>
    <p>{`See how metric data is structured.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "/experience-cloud/cloud-manager/src/pages/guides/api-usage/editing-and-deleting-pipelines.md"
      }}>{`Editing and Deleting Pipelines`}</a></p>
    <p>{`See how to edit and delete pipelines.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "/experience-cloud/cloud-manager/src/pages/guides/api-usage/advancing-and-cancelling-steps.md"
      }}>{`Advancing and Cancelling Steps`}</a></p>
    <p>{`See how to advance and cancel steps using the API.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "/experience-cloud/cloud-manager/src/pages/guides/api-usage/creating-programs-and-environments.md"
      }}>{`Creating Programs and Environments`}</a></p>
    <p>{`See how to create programs and environments.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "/experience-cloud/cloud-manager/src/pages/guides/api-usage/adding-custom-domain-names.md"
      }}>{`Adding Custom Domain Names`}</a></p>
    <p>{`Learn how to add your own custom domain names to an environment.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      